import React, { FC, useEffect, useState } from 'react';
import { LandscapeAboutLandscapeAddTemplate } from '../../templates';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import { useNavigate, useParams } from 'react-router-dom';
import cn from 'classnames';
import styles from './LandscapeAboutLandscapeEditPage.module.css';
import { EntityGalleryTileResponseDto } from '../../../store/landscapeAPI/galleryTile/dto/response/entity-gallery-tile-response.dto';
import {
  fetchEntityGalleryTileById,
  updateEntityGalleryTile,
} from '../../../store/landscapeAPI/galleryTile/reducers/entity-gallery-tile.slice';
import { ImageMeta } from '../../../store/mediaAPI/media/dto/request/media-save-request';
import { MediaSaveResponseDto } from '../../../store/mediaAPI/media/dto/response/media-save-response';
import { saveMedia } from '../../../store/mediaAPI/media/reducers/media.slice';
import Spinner from '../../atoms/Spinner/Spinner';
import { EntityGalleryTileUpdateRequestDto } from '../../../store/landscapeAPI/galleryTile/dto/request/entity-gallery-tile-update-request.dto';
import { fetchLandscapeById } from '../../../store/landscapeAPI/landscape/reducers/landscape.slice';
import { LocalesLanguagesConstants } from '../../../locales/locales';

interface LandscapeAboutLandscapeEditPageProps {}

const LandscapeAboutLandscapeEditPage: FC<
  LandscapeAboutLandscapeEditPageProps
> = () => {
  const { id } = useParams();
  const { galleryTileId } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [imageMeta, setImageMeta] = useState<ImageMeta>();
  const [galleryTile, setGalleryTile] =
    useState<EntityGalleryTileResponseDto>();
  const { status } = useSelector(
    (state: RootState) => state.entityGalleryTileSlice
  );

  useEffect(() => {
    if (galleryTileId) {
      dispatch(fetchEntityGalleryTileById(galleryTileId))
        .unwrap()
        .then((response: EntityGalleryTileResponseDto) =>
          setGalleryTile(response)
        );
    }
  }, [galleryTileId, dispatch]);

  const handleOnChange = (galleryTile: EntityGalleryTileResponseDto) => {
    setGalleryTile(galleryTile);
  };

  const handleImageOnChange = (imageMeta: ImageMeta) => {
    setImageMeta(imageMeta);
  };

  const handleCancel = () => {
    navigate(`/landscapes/edit/${id}/about/landscape`);
  };

  const callbackFn = async (galleryTile: EntityGalleryTileResponseDto) => {
    let image: MediaSaveResponseDto = {
      href: galleryTile.blobUrl ?? '',
    };
    if (galleryTile.blobUrl && galleryTile.blobUrl !== '' && imageMeta) {
      const formData = new FormData();
      formData.append(
        'file',
        new Blob([galleryTile.blobUrl], {
          type: imageMeta?.imageType ?? 'image/png',
        }),
        imageMeta?.imageSrc
      );
      image = (await dispatch(saveMedia(formData)))
        .payload as MediaSaveResponseDto;
    }
    const galleryTileToUpdate: EntityGalleryTileUpdateRequestDto = {
      compactId: galleryTile.compactId,
      entityId: galleryTile.entityId,
      entityType: galleryTile.entityType,
      blobUrl: image.href,
      blobType: galleryTile.blobType,
      thumbnailImageUrl: galleryTile.thumbnailImageUrl,
      blobTitle: galleryTile.blobTitle,
      blobDescription: galleryTile.blobDescription,
      isMap: galleryTile.isMap,
      id: galleryTile.id,
      published: galleryTile.published,
    };
    await dispatch(updateEntityGalleryTile(galleryTileToUpdate));
    if (id) {
      dispatch(
        fetchLandscapeById({ id: id, language: LocalesLanguagesConstants.en })
      );
    }
    navigate(`/landscapes/edit/${id}/about/landscape`);
  };

  if (status === 'loading') {
    return <Spinner />;
  }

  return (
    <>
      {galleryTile && (
        <div className={cn(styles.lanscapeAboutLandscapeAddWrapper)}>
          <LandscapeAboutLandscapeAddTemplate
            handleOnChange={handleOnChange}
            galleryTile={galleryTile}
            handleImageOnChange={handleImageOnChange}
            callbackFn={callbackFn}
            handleCancel={handleCancel}
          />
        </div>
      )}
    </>
  );
};

export default LandscapeAboutLandscapeEditPage;
